import ContactFieldValidations from "../../mixins/contact-mixin";
import ContactFormListsMixin from "../../mixins/contact-form-lists-mixin";

Vue.component("create-contact", {

    mixins: [ContactFieldValidations, ContactFormListsMixin],

    props: ["role", "contactable", "contactableId", "createModalTitle", "hideJuristicSection"],

    data () {
        return {
            form: new AppForm({
                represents_juristic_entity: false,
                contactable_id: this.contactableId,
                contactable: this.contactable,
                editing: false
            }),
            contactNameSet: false
        };
    },

    methods: {

        createContact () {

            this.form.role = this.role;

            App.post("/contacts/create", this.form)
            .then(response => {
                Bus.$emit("contact-created");
                toastr.success("New contact created!");
                this.clearForm();
            })
            .catch(errors => {
                toastr.error("Create contact failed!");
            });
        },

        showJuristicSection () {
            return this.contactable !== "App\\ServiceProvider";
        },

        clearForm () {
            this.form = new AppForm({
                represents_juristic_entity: false,
                contactable_id: this.contactableId,
                contactable: this.contactable
            });
        },

        formatDesignation () {
            this.form.designation = this.$options.filters.titlecase(this.form.designation);
        },

        modalTitle () {
            if (this.createModalTitle) {
                return this.createModalTitle;
            }

            let name = null;

            if (this.form.first_names) {
                name = this.form.first_names;
            }

            if (name && this.form.last_name) {
                if (this.form.title) {
                    name = this.form.title + ". " + this.form.first_names + " " + this.form.last_name;
                } else {
                    name = this.form.first_names + " " + this.form.last_name;
                }
            }

            if (!name && this.form.title && this.form.last_name) {
                name = this.form.title + ". " + this.form.last_name;
            }

            if (name) {
                return name;
            } else if (!name && this.role) {
                return "New " + this.role;
            } else {
                return "New Contact";
            }
        }
    }

});
